import './headerFullWidth.css';
export const fullWidthStyles = "f1mvwx8f";
export const ltrStyles = "l1illq4";
export const rtlStyles = "r16k3x6k";